import { takeLatest } from 'redux-saga/effects';
import generateSaga from '../utils/generateSaga';
import {
  fetchBinaryOptionDiscretionaryAddOns,
  updateBinaryOptionDiscretionaryAddOn,
} from '../reducers/binaryOptionDiscretionaryAddOnReducer';

export default function* watch() {
  yield takeLatest(
    fetchBinaryOptionDiscretionaryAddOns.TRIGGER,
    generateSaga(fetchBinaryOptionDiscretionaryAddOns),
  );
  yield takeLatest(
    updateBinaryOptionDiscretionaryAddOn.TRIGGER,
    generateSaga(updateBinaryOptionDiscretionaryAddOn, {
      loading: 'Updating Binary Option Discretionary Add-on',
      success: 'Binary Option Discretionary Add-on Updated',
    }),
  );
}
